export const LOADING_EMAILCAMPAIGN = "LOADING_EMAILCAMPAIGN";
export const GET_EMAILCAMPAIGN_LIST = "GET_EMAILCAMPAIGN_LIST";
export const REMOVE_EMAILCAMPAIGN = "REMOVE_EMAILCAMPAIGN";
export const ADD_EMAILCAMPAIGN = "ADD_EMAILCAMPAIGN";
export const UPDATE_EMAILCAMPAIGN = "UPDATE_EMAILCAMPAIGN";
export const GET_EMAILCAMPAIGNID = "GET_EMAILCAMPAIGNID";
export const UPDATE_EMAILCAMPAIGN_STATUS = "UPDATE_EMAILCAMPAIGN_STATUS";